import { useEffect, useState } from 'react'
import Card from '../components/Card'
import CardGrid from '../components/CardGrid'
import Hero from '../components/Hero'
import { API_URL } from '../../constants'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { languageUtil } from '../../util/languageUtils'
import { ErrorOverlay, LoadingOverlay } from '../../shared/components/Loading'

const ReligiousDues = () => {
    const [dues, setDues] = useState([])
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { language } = languageUtil()
    const rtl = language === 'ar'
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await fetch(`${API_URL}/religious-dues`, {
                    headers: {
                        'Accept-Language': 'en',
                    },
                })
                const json = await response.json()

                if (json.success && Array.isArray(json.data)) {
                    setDues(json.data)
                } else {
                    console.error('Invalid data structure:', json)
                    setError(`Invalid data structure: ${json}`)
                }
            } catch (error) {
                console.error('Failed to fetch dues:', error)
                setError(`Failed to fetch dues: ${error}`)
            } finally {
                setLoading(false)
            }
        }

        fetchNews()
    }, [])

    const renderCard = item =>
        item.is_active === 1 || item.is_active === '1' ? (
            <Card
                key={item.id}
                label={rtl ? item.title_ar : item.title_en || item.title}
                description={rtl ? item.subtitle_ar : item.subtitle_en || item.subtitle}
                imageSrc={item.header_image}
                buttonLabel={
                    rtl ? item.call_to_action_ar : item.call_to_action_en || item.call_to_action
                }
                onButtonClick={() => navigate(`/religious-dues/${item.id}`)}
            >
                <p>
                    {rtl
                        ? item.small_description_ar
                        : item.small_description_en || item.small_description}
                </p>
            </Card>
        ) : null

    return (
        <div>
            <Hero
                title={t('religious-dues.title')}
                imageUrl='https://images.unsplash.com/photo-1728135394135-58c2236cd2bb?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                size='medium'
            />
            <div className='mx-auto my-8 max-w-7xl'>
                {loading ? (
                    <LoadingOverlay message={t('loading')} />
                ) : (
                    // <p className='text-center text-gray-500'>{t('loading')}</p>
                    <div>
                        {error && <ErrorOverlay message={error} onClose={() => setError(null)} />}
                        <CardGrid data={dues} renderCard={renderCard} />
                    </div>
                )}
            </div>
        </div>
    )
}

export default ReligiousDues
